/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GenerateOmniEmbedUrlQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GenerateOmniEmbedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { response: (
    { __typename?: 'OmniEmbedUrlResponse' }
    & Pick<Types.OmniEmbedUrlResponseGQLType, 'url' | 'error'>
    & { embedContext?: Types.Maybe<(
      { __typename?: 'OmniEmbedContext' }
      & Pick<Types.OmniEmbedContextGQLType, 'entityKey' | 'analyticsClientId' | 'environment' | 'path' | 'folderLabel' | 'folderPath'>
    )> }
  ) }
);

export type IsOmniAnalyticsConfiguredQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type IsOmniAnalyticsConfiguredQueryGQLType = (
  { __typename?: 'Query' }
  & { isConfigured: Types.QueryGQLType['isOmniAnalyticsConfigured'] }
);


export const GenerateOmniEmbedUrlDocumentGQLType = gql`
    query GenerateOmniEmbedUrl($organizationId: UUID!) {
  response: generateOmniEmbedUrl(organizationId: $organizationId) {
    url
    error
    embedContext {
      entityKey
      analyticsClientId
      environment
      path
      folderLabel
      folderPath
    }
  }
}
    `;

/**
 * __useGenerateOmniEmbedUrlQuery__
 *
 * To run a query within a React component, call `useGenerateOmniEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOmniEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOmniEmbedUrlQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGenerateOmniEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>(GenerateOmniEmbedUrlDocumentGQLType, options);
      }
export function useGenerateOmniEmbedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>(GenerateOmniEmbedUrlDocumentGQLType, options);
        }
export type GenerateOmniEmbedUrlQueryHookResult = ReturnType<typeof useGenerateOmniEmbedUrlQuery>;
export type GenerateOmniEmbedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGenerateOmniEmbedUrlLazyQueryGQLType>;
export type GenerateOmniEmbedUrlQueryResultGQLType = Apollo.QueryResult<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>;
export const IsOmniAnalyticsConfiguredDocumentGQLType = gql`
    query IsOmniAnalyticsConfigured($organizationId: UUID!) {
  isConfigured: isOmniAnalyticsConfigured(organizationId: $organizationId)
}
    `;

/**
 * __useIsOmniAnalyticsConfiguredQuery__
 *
 * To run a query within a React component, call `useIsOmniAnalyticsConfiguredQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOmniAnalyticsConfiguredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOmniAnalyticsConfiguredQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useIsOmniAnalyticsConfiguredQuery(baseOptions: Apollo.QueryHookOptions<IsOmniAnalyticsConfiguredQueryGQLType, IsOmniAnalyticsConfiguredQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOmniAnalyticsConfiguredQueryGQLType, IsOmniAnalyticsConfiguredQueryVariablesGQLType>(IsOmniAnalyticsConfiguredDocumentGQLType, options);
      }
export function useIsOmniAnalyticsConfiguredLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<IsOmniAnalyticsConfiguredQueryGQLType, IsOmniAnalyticsConfiguredQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOmniAnalyticsConfiguredQueryGQLType, IsOmniAnalyticsConfiguredQueryVariablesGQLType>(IsOmniAnalyticsConfiguredDocumentGQLType, options);
        }
export type IsOmniAnalyticsConfiguredQueryHookResult = ReturnType<typeof useIsOmniAnalyticsConfiguredQuery>;
export type IsOmniAnalyticsConfiguredLazyQueryGQLTypeHookResult = ReturnType<typeof useIsOmniAnalyticsConfiguredLazyQueryGQLType>;
export type IsOmniAnalyticsConfiguredQueryResultGQLType = Apollo.QueryResult<IsOmniAnalyticsConfiguredQueryGQLType, IsOmniAnalyticsConfiguredQueryVariablesGQLType>;